import { render, staticRenderFns } from "./CmbLocalidades.vue?vue&type=template&id=7cb90a1a&"
import script from "./CmbLocalidades.vue?vue&type=script&lang=js&"
export * from "./CmbLocalidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports